import React from "react";
import { useOutletContext } from "react-router-dom";
import { MessageCircle, Phone, LifeBuoy, Clock } from "lucide-react";
import { BRAND } from "../../lib/api";
import { Card, Button } from "../../components/ui-kit";
import AcademyTitleBadge from "../../academy/AcademyTitleBadge";

export default function Assistenza() {
  const { ctx } = useOutletContext();
  const tenant = ctx.tenant || {};
  const preset = `Salve, sono ${ctx.user?.name} di ${tenant.name}. Ho bisogno di assistenza HACCP.`;
  const wa = `https://wa.me/${BRAND.whatsapp.replace(/\D/g, "")}?text=${encodeURIComponent(preset)}`;
  return (
    <div className="max-w-2xl space-y-6" data-testid="assistenza-page">
      <div>
        <p className="text-xs uppercase tracking-[0.18em] text-slate-400 font-body">Assistenza</p>
        <div className="flex flex-wrap items-center gap-2"><h1 className="font-heading text-3xl font-bold">Contatta Dottor D</h1><AcademyTitleBadge /></div>
      </div>
      <div className="bg-navy text-white border border-navy shadow-card rounded-xl p-8 text-center">
        <div className="w-14 h-14 rounded-2xl bg-white/10 grid place-items-center mx-auto mb-4"><LifeBuoy className="w-7 h-7 text-gold-bright" /></div>
        <h2 className="font-heading text-2xl font-semibold">DF Consulting Group</h2>
        <p className="text-white/70 font-body mt-2 mb-6">Il consulente è a tua disposizione per ogni necessità sul Piano di Autocontrollo. Risposta entro 24h, 7 giorni su 7.</p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <a href={wa} target="_blank" rel="noreferrer" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-[#25D366] text-white font-medium min-h-[44px]" data-testid="assist-whatsapp"><MessageCircle className="w-5 h-5" /> Scrivi su WhatsApp</a>
          <a href={`tel:${BRAND.phone}`} className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-gold text-white font-semibold min-h-[44px]" data-testid="assist-call"><Phone className="w-5 h-5" /> Chiama ora</a>
        </div>
      </div>
      <Card className="p-5 flex items-center gap-3 text-sm text-slate-500">
        <Clock className="w-5 h-5 text-gold" /> Il messaggio precompilato include azienda e sede, senza dati sensibili.
      </Card>
    </div>
  );
}
